import { useCallback, useState } from "react";
import type { UseGridReview } from "./types";

export const useGridReview: UseGridReview = () => {
  const [isGridReviewOpen, setIsGridReviewOpen] = useState(false);

  const openGridReview = useCallback(() => {
    setIsGridReviewOpen(true);
  }, []);

  const closeGridReview = useCallback(() => {
    setIsGridReviewOpen(false);
  }, []);

  return { isGridReviewOpen, openGridReview, closeGridReview };
};
